/* eslint-disable import/no-cycle */
import type { ParagraphType } from '@packages/cms-components/interfaces/components';
import { ComponentTypes } from '@packages/cms-components/interfaces/components';
import {
  createFilterContentSnippetsForCurrentTime,
  CmsImage,
  Html,
  ExternalScript,
} from '@packages/cms-components';
import BlockText from './BlockText';
import BlockList from './BlockList';
import BlockImage from './BlockImage';
import BlockBadges from './BlockBadges';
import ImageGroup from './ImageGroup';

type ComponentRecognizerProps = {
  item: ParagraphType;
};

const ComponentRecognizerFooter = ({ item }: ComponentRecognizerProps): JSX.Element | null => {
  const filterContentSnippetsForCurrentTime = createFilterContentSnippetsForCurrentTime({});
  const showContent = filterContentSnippetsForCurrentTime(item);

  if (showContent) {
    switch (item.type) {
      case ComponentTypes.BlockText:
        return <BlockText data={item} />;
      case ComponentTypes.BlockList:
        return <BlockList data={item} />;
      case ComponentTypes.BlockImage:
        return <BlockImage data={item} />;
      case ComponentTypes.BlockBadges:
        return <BlockBadges data={item} />;
      case ComponentTypes.Html:
        return <Html data={item} />;
      case ComponentTypes.FooterGroupImage:
        return <ImageGroup data={item} />;
      case ComponentTypes.SvgFile:
      case ComponentTypes.ImageFooter:
      case ComponentTypes.ImageSimple:
        return <CmsImage data={item} />;
      case ComponentTypes.ExternalScript:
        return <ExternalScript data={item} />;
      default:
        return null;
    }
  }
  return null;
};

// eslint-disable-next-line import/no-default-export
export default ComponentRecognizerFooter;
